<template>
  <div id="process-app-id">
    <router-view />
  </div>
</template>

<script>
// import SystemAPI from "@/apis/components/SystemAPI.js";
// import LocalizeAPI from "@/apis/base/localize/LocalizeAPI.js";
import i18n from "@/i18ns/i18n.js";

export default {
  name: "AppProcess",
  data() {
    return {
      userInfo: {},
    };
  },
  // beforeCreate() {
  //   /**
  //    * Hàm lấy thông tin user đang đăng nhập
  //    * updatedby phquan 23/12/2020
  //    */
  //   SystemAPI.getCurrentUser()
  //     .then((res) => {
  //       if (res && res.data.Success && res.data.Data) {
  //         let userInfo = res.data.Data.UserData;

  //         // Thêm thông tin quyền - nhhoang1
  //         userInfo.IsAdmin = res.data.Data.IsAdmin;
  //         userInfo.IsAdminApp = res.data.Data.IsAdminApp;

  //         let permissions = res.data.Data.Permissions;

  //         // * Nếu không có quyền thì show màn 403 - hcphi
  //         if (permissions.Request_Permission.length == 0) {
  //           this.$PlatformFunction.show403();
  //           return;
  //         }

  //         this.userInfo = res.data.Data.UserData;

  //         if (userInfo)
  //           if (!userInfo) {
  //             this.$PlatformFunction.show403();
  //             return;
  //           }
  //       } else {
  //         this.$PlatformFunction.show403();
  //       }
  //     })
  //     .catch((error) => {
  //       if (
  //         error &&
  //         ((error.response && error.response.status == 403) ||
  //           (error.request && error.request.status == 403))
  //       ) {
  //         this.$PlatformFunction.show403();
  //       }
  //     });
  // },
  mounted() {
    // this.handleChangeLanguage();
  },
  methods: {
    /**
     * Hàm xử lý thay đổi ngôn ngữ
     * CreatedBy: HNANH(07/04/2021)
     * Modified by: DNCuong bổ sung phần localized
     */
    // handleChangeLanguage() {
    //   var lang = this.$PlatformFunction.getAppLanguage();
    //   if (lang) {
    //     LocalizeAPI.get(`?resourceID=common&lang=${lang}`)
    //       .then((res) => {
    //         if (res.data) {
    //           i18n.mergeLocaleMessage(lang, res.data);
    //           return;
    //         }
    //         i18n.mergeLocaleMessage(lang, res);
    //       })
    //       .catch((err) => console.log(err));
    //   } else {
    //     LocalizeAPI.get(`?resourceID=common&lang=vi`)
    //       .then((res) => {
    //         if (res.data) {
    //           i18n.mergeLocaleMessage("vi", res.data);
    //           return;
    //         }
    //         i18n.mergeLocaleMessage("vi", res);
    //       })
    //       .catch((err) => console.log(err));
    //   }
    // },
  },
};
</script>
<style lang="scss">
#process-app-id {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;

}
label {
  outline: none;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
